var authorization = require('./services/authorization');
var router = require('./services/router');
var helpers = require('./services/helpers');

var preloader = require('./components/preloader');
var messages = require('./components/messages');

var ResetPasswordPage = function () {
    var self = this;

    this.current_password = ko.observable('');
    this.new_password = ko.observable('');

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.getData = function () {
        return {
            current_password: self.current_password(),
            new_password: self.new_password()
        }
    };

    this.isValid = function () {
        var messages_list = [];
        var target_focus;

        self.current_password(self.current_password().trim());
        self.new_password(self.new_password().trim());

        if (self.new_password().length == 0) {
            target_focus = 'new_password';
            messages_list.push('Please, fill "new password" field');
        }
        if (self.current_password().length == 0) {
            target_focus = 'current_password';
            messages_list.push('Please, fill in "current password" field');
        }

        if (messages_list.length == 0) return true;

        messages.addItems(messages_list.reverse(), {clear: true});
        helpers.focusSequence(messages_list.join( ), function () {
            self.focused(target_focus);
        });

        return false;
    };

    this.clean = function () {
        self.current_password('');
        self.new_password('');
    };

    this.resetPassword = function () {
        messages.removeAllItems();

        if(!self.isValid()) {
            self.clean();
            return;
        }

        preloader.show('reset-password');
        authorization.changePassword(function (status, message) {
            preloader.hide('reset-password');
            self.clean();

            if (!status) {
                helpers.focusSequence(message, function () {
                    self.focused('current_password');
                });

                return;
            }

        }, self.getData());
    };

    this.onShow = function () {
        self.focused('title');
    };
    this.onHide = function () {
        self.clean();
        self.focused('');
    }
};

module.exports = ResetPasswordPage;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ResetPasswordPage.js
// module id = 27
// module chunks = 0